import { ReactNode, useEffect, useState } from 'react';

// third-party
import { IntlProvider, MessageFormatElement } from 'react-intl';

// project-imports
import useConfig from '@/hooks/useConfig';
import { I18n } from '@/types/base/config';

// load locales files
const loadLocaleData = (locale: I18n) => {
  switch (locale) {
    // case 'fr':
    //   return import('@/locales/fr.json');
    // case 'ro':
    //   return import('@/locales/ro.json');
    // case 'zh':
    //   return import('@/locales/zh.json');
    case 'en':
      return import('@/locales/en.json');
    case 'th':
    default:
      return import('@/locales/th.json');
  }
};

interface Props {
  children: ReactNode;
}

// ==============================|| LOCALIZATION ||============================== //

export default function Locales({ children }: Props) {
  const { i18n } = useConfig();

  const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();

  useEffect(() => {
    loadLocaleData(i18n).then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
      setMessages(d.default);
    });
  }, [i18n]);

  return messages ? (
    <IntlProvider locale={i18n} defaultLocale="th" messages={messages}>
      {children}
    </IntlProvider>
  ) : (
    <div />
  );
}
